import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import MetersLayer from "../components/MetersLayer";

const MeterListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle="Meters">

        {/* MetersLayer */}
        <MetersLayer />
      </MasterLayout>
    </>
  );
};

export default MeterListPage;
